import * as Types from './Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import { RootState } from 'src/reducers/RootReducer';
import Testimonial from 'src/entities/Testimonial';
import ValidatorService from 'src/services/validation/Validation.service';

export interface GetTestimonialAttempt extends Action {
  type: Types.GET_TESTIMONIAL_ATTEMPT;
}

export interface GetTestimonialSuccess extends Action {
  type: Types.GET_TESTIMONIAL_SUCCESS;
  payload: Testimonial;
}

export interface GetTestimonialFailure extends Action {
  type: Types.GET_TESTIMONIAL_FAILURE;
  payload: {};
}

export type GetTestimonialAction = GetTestimonialAttempt | GetTestimonialSuccess | GetTestimonialFailure;

export interface GetTestimonialThunk extends ThunkAction<Promise<GetTestimonialAction>, RootState, string> {
}

export const getTestimonialAttempt: ActionCreator<GetTestimonialAttempt> = () => (
  {
    type: Types.GET_TESTIMONIAL_ATTEMPT
  }
);

export const getTestimonialSuccess: ActionCreator<GetTestimonialSuccess> = (
  testimonial: Testimonial) => (
  {
    type: Types.GET_TESTIMONIAL_SUCCESS,
    payload: testimonial
  }
);

export const getTestimonialFailure: ActionCreator<GetTestimonialFailure> = (error: {}) => (
  {
    type: Types.GET_TESTIMONIAL_FAILURE,
    payload: error
  }
);

export const getTestimonial: ActionCreator<GetTestimonialThunk> =
  (): GetTestimonialThunk => {
    return (dispatch: Dispatch<RootState>): Promise<GetTestimonialAction> => {
      dispatch(getTestimonialAttempt());

      return ApiClient.testimonial.get('')
        .then((response: AxiosResponse<Testimonial>): GetTestimonialSuccess => {
          const testimonial: Testimonial = response.data;
          return dispatch(getTestimonialSuccess(testimonial));
        }).catch((e: { response: { data: { error: {} } } }): GetTestimonialFailure => {
          const errorMessages = ValidatorService
          .translateValidations(e && e.response && e.response.data && e.response.data.error);

          return dispatch(getTestimonialFailure(errorMessages));
        });
    };
  };



// WEBPACK FOOTER //
// ./src/actions/testimonial/get/GetTestimonial.actions.tsx